
import { defineComponent, computed, onMounted, onUnmounted } from 'vue';
import { useDiskStore } from '@/store/disk';

export default defineComponent({
  setup() {
    const diskStore = useDiskStore();
    const diskInfo = computed(() => diskStore.getDiskInfoData);
    let intervalId: ReturnType<typeof setInterval>;

    const formatGB = (bytes: number): string => {
      if (!bytes || isNaN(bytes)) return '0';
      return (bytes / 1073741824).toFixed(2); // 소수점 둘째자리까지 표시
    };

    const fetchStorageSize = async () => {
      diskStore.getDiskInfo()
    };

    onMounted(() => {
      fetchStorageSize();
      intervalId = setInterval(fetchStorageSize, 30000);
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      diskInfo,
      formatGB
    };
  },
});
